/** Confirmation copy shown before one appointment is removed from Eligibility Status. */
export const ELIGIBILITY_REMOVE_CONFIRMATION = {
  title: "Are you sure you want to remove this appointment?",
  description: (clientName: string, appointmentLabel: string) =>
    `${clientName}'s appointment on ${appointmentLabel} will no longer appear on the Eligibility Status list.`,
} as const;

/** Success toast shown after an appointment is removed from Eligibility Status. */
export const ELIGIBILITY_REMOVE_SUCCESS_TOAST = {
  title: "Removed from eligibility list",
  message: (clientName: string, appointmentLabel: string) =>
    `${clientName}'s appointment on ${appointmentLabel} was removed from the Eligibility Status list.`,
} as const;
